import { render, staticRenderFns } from "./ListarRegimenJubilatorio.vue?vue&type=template&id=3454a462&"
import script from "./ListarRegimenJubilatorio.vue?vue&type=script&lang=js&"
export * from "./ListarRegimenJubilatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports